import { observer } from "mobx-react-lite";
import { ContextProps } from "@menu/core/types";
import { NavItem } from "@menu/core/types/nav-item";
import { DisplayItem } from "@menu/core/menu.context";
import MobileParentNav from "./mobile-parent-nav";
import MobileSubNav from "./mobile-sub-nav";
import MobileChannels from "./mobile-channels";

type MobileSideNavProps = ContextProps & {
    onSelectHeaderLink: (e: any, link: NavItem) => void
}

const MobileSideNav = observer((props: MobileSideNavProps) => {
    const { context, onSelectHeaderLink } = props;

    if (!context.isMobile || !context.displayMobileNav) {
        return null;
    }

    const select = (e: any, x: NavItem) => {
        onSelectHeaderLink(e, x);
        context.updateDisplayItem(DisplayItem.SubNav);
    }

    const back = () => {
        context.clearArea();
        context.updateDisplayItem(DisplayItem.MainNav);
    }

    return (<nav id="mobile-side-nav">
        <MobileParentNav
            context={context}
            onSelect={select} />

        <MobileSubNav
            context={context}
            selectedItem={context.selectedArea}
            onBack={back} />

        <MobileChannels context={context} />
    </nav>);
});

export default MobileSideNav;